// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__12tWA","balanceDisclaimer":"posDashboard_balanceDisclaimer__2Ao6w"};